import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CancellationPoliciesCard } from "./component";
import { IStoreState } from "../../../../reducers/types";

import { getIsTripVoidWindowEligible } from "../../../flight-shop/reducer";
import { getHotelShopChosenProduct } from "../../../hotel-shop/reducer";
import { getPackagedRoomComponent } from "../../../package-identity/reducer/selectors";
import { toHotelCancellationPolicyV2 } from "../../../hotel-shop/utils/packageSnapshotAdapters";
import { getPackageHotelIdentity } from "../../../hotel-shop/utils/usePackageHotelIdentity";

export const mapStateToProps = (state: IStoreState) => {
  const packagedRoomComponentV2 = getPackagedRoomComponent(state);
  const cancellationPolicyV2 = packagedRoomComponentV2?.shopDetails
    ?.cancellationPolicyV2
    ? toHotelCancellationPolicyV2(
        packagedRoomComponentV2.shopDetails.cancellationPolicyV2
      )
    : undefined;

  return {
    chosenProduct: getHotelShopChosenProduct(state),
    isVoidWindowEligible: getIsTripVoidWindowEligible(state),
    // v0-first, v2-fallback by presence — matches getPackageHotelIdentity's
    // own resolution order for this field exactly.
    cancellationSummary: getPackageHotelIdentity(state).cancellationSummary,
    // v2-sourced: read from the GetPackage snapshot instead of the handoff.
    // NOT migrated to getPackageHotelIdentity's cancellationPolicyV2 — this
    // card's primary source is the legacy chosenProduct.cancellationPolicy
    // field (see component.tsx), with this v2-only value used only as a
    // fallback when that field is absent. The shared accessor instead
    // resolves v0's own chosenProduct.cancellationPolicyV2 vs. the v2
    // snapshot — a different field and a different order, so this stays
    // as its own inline logic rather than forcing a mismatch for uniformity.
    cancellationPolicyV2,
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CancellationPoliciesCardConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCancellationPoliciesCard = withRouter(
  connector(CancellationPoliciesCard)
);
